import { render, staticRenderFns } from "./d3.vue?vue&type=template&id=06a38394&scoped=true"
import script from "./d3.vue?vue&type=script&lang=js"
export * from "./d3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a38394",
  null
  
)

export default component.exports